import type { ModelsNews } from '@/api/generated-api'

/**
 * Fields the backend serves that models.News does not carry yet. They read as
 * undefined until the generated client catches up, which leaves the article
 * exactly as it is today.
 */
export type NewsWithBannerFields = ModelsNews & {
  header_banner_url?: string
  cta_enabled?: boolean
}

/** Absent means shown: articles written before the switch keep their CTA. */
export function isCtaEnabled(news?: NewsWithBannerFields): boolean {
  return news?.cta_enabled !== false
}

/** Trimmed banner url, or undefined when the article has none. */
export function getHeaderBannerUrl(
  news?: NewsWithBannerFields
): string | undefined {
  return news?.header_banner_url?.trim() || undefined
}
